import { createContext, use } from "react";

import type { NgwMapInstance } from "./types";

export interface MapWorkspaceContextValue {
  ngwMap: NgwMapInstance | null;
}

export const MapWorkspaceContext = createContext<MapWorkspaceContextValue>({
  ngwMap: null,
});

export function useMapWorkspace() {
  const context = use(MapWorkspaceContext);

  if (!context) {
    throw new Error(
      "useMapWorkspace must be used within a MapWorkspace provider",
    );
  }

  return context;
}
